import { Metrics } from '../services/metrics';

export function useMetrics() {
  return Metrics.getLogger();
  // TODO add main event name
}
